<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "EximPpjkLogin",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  